<template>
  <base-page-layout ref="base-page" class="client-details" title="Detalhes do cliente">
    <v-layout>
      <v-flex xs3>
        <busca-component class="overlay" search-type="cliente" />
      </v-flex>
    </v-layout>

    <v-layout class="mt-4">
      <v-flex>
        <v-card class="mt-2">
          <mf-loading loader-type="dynamic" :dynamic-amount="1" loader="busca-cliente">
            <v-card-title>
              <v-layout>
                <span class="pa-1 table-card-title">{{ clienteNomeCodigo }}</span>
              </v-layout>
            </v-card-title>
          </mf-loading>
        </v-card>
      </v-flex>
    </v-layout>

    <v-divider class="my-4" />

    <v-card>
      <mf-loading loader-type="dynamic" :dynamic-amount="2" :boolean-loader="loading">
        <v-data-table :items="[clienteSelecionado]" :headers="tableHeaders" hide-default-footer disable-pagination>
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['COD_ID_CLIENTE_SEARCH'] }}</td>
              <td>{{ item['NOM_NOME_SEARCH'] }}</td>
              <td>{{ item['DES_BAIRRO_SEARCH'] }}</td>
              <td>{{ item['DES_TIPO_CLIENTE_SEARCH'] | filtroPessoa }}</td>
              <td>{{ item['DES_SEXO_CLIENTE_SEARCH'] }}</td>
              <td class="text-right">{{ item['NUM_IDADE_SEARCH'] }}</td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </v-card>

    <v-container fluid class="pa-0">
      <v-row class="pa-4">
        <v-spacer />
        <filters-menu :filters="['lojas', 'data']" default-date="desdeInicio" />
      </v-row>
    </v-container>

    <v-container class="px-0 pb-0" fluid grid-list-lg>
      <v-layout>
        <v-flex v-for="(card, index) in cards" :key="index" xs6>
          <cbm-card
            :number-text="card.value"
            :title="card.text"
            :loader="card.loader"
            use-loader
            :is-currency="card.isCurrency"
            unset-percentage-colors
            simple-card
          />
        </v-flex>
      </v-layout>
    </v-container>

    <produto-mais-comprado class="mt-3" />

    <v-container class="pa-0" fluid grid-list-lg>
      <v-layout wrap row>
        <v-flex xs4>
          <horas-mais-frequentes-card :items="tabelaHorasMaioresCompras" module="clientes" />
        </v-flex>
        <v-flex xs4>
          <dias-mais-frequentes-card :items="tabelaDiasSemanaMaioresCompras" module="clientes" />
        </v-flex>
        <v-flex xs4>
          <dia-mes-mais-frequente-card :items="tabelaDiasMaioresCompras" module="clientes" />
        </v-flex>
      </v-layout>
    </v-container>

    <hora-chart :data="chartHorasMaioresCompras" />
    <dia-semana-chart :data="chartDiasSemanaMaioresCompras" />
    <dia-mes-chart :data="chartDiasMaioresCompras" />

    <coupons-table :user-id="$route.params.id" />
  </base-page-layout>
</template>

<script>
import find from 'lodash/find'
import range from 'lodash/range'
import orderBy from 'lodash/orderBy'
import ProdutoMaisComprado from '@/modules/clientes/detalhes-cliente/views/pages/ProdutoMaisComprado.vue'
import BasePageLayout from '@/components/BasePageLayout.vue'
import HorasMaisFrequentesCard from '@/components/busca-detalhes/HorasMaisFrequentesCard.vue'
import DiasMaisFrequentesCard from '@/components/busca-detalhes/DiasMaisFrequentesCard.vue'
import DiaMesMaisFrequenteCard from '@/components/busca-detalhes/DiaMesMaisFrequenteCard.vue'
import CbmCard from '@/components/CbmCard.vue'
import BuscaComponent from '@/components/busca-detalhes/BuscaComponent.vue'
import { assertArray, localeString } from '@/config/helpers.js'
import { mapActions, mapGetters, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'

export default {
  components: {
    BasePageLayout,
    HorasMaisFrequentesCard,
    DiasMaisFrequentesCard,
    DiaMesMaisFrequenteCard,
    HoraChart: () => import('@/components/busca-detalhes/HoraChart.vue'),
    DiaSemanaChart: () => import('@/components/busca-detalhes/DiaSemanaChart.vue'),
    DiaMesChart: () => import('@/components/busca-detalhes/DiaMesChart.vue'),
    CbmCard,
    BuscaComponent,
    FiltersMenu: () => import('@/components/FiltersMenu.vue'),
    CouponsTable: () => import('@/modules/clientes/detalhes-cliente/views/components/CouponsTable.vue'),
    ProdutoMaisComprado,
  },
  filters: {
    filtroPessoa(value) {
      if (value === 'F') return 'PF'
      if (value === 'J') return 'PJ'
      return '-'
    },
  },
  data: () => ({
    loading: true,
    clienteSelecionado: null,
  }),
  computed: {
    ...mapState({
      stateHora: (state) => state.clientes.horasMaioresCompras,
      stateMes: (state) => state.clientes.diasMaioresCompras,
      stateSemana: (state) => state.clientes.diasSemanaMaioresCompras,
      stateFilters: (state) => state.filters,
    }),
    ...mapGetters(['ticketMedioClientes', 'mediaItensClientes', 'numeroCupons', 'faturamento']),
    arrayHora() {
      let array = []
      for (let count of range(24)) {
        let stateObject = find(this.stateHora, { NUM_HORA: count })
        if (stateObject) array.push(stateObject)
        else array.push({ NUM_HORA: count, NUM_TOTAL_CUPONS: 0 })
      }
      return array
    },
    arraySemana() {
      let array = []
      for (let count of range(7)) {
        let stateObject = find(this.stateSemana, { NUM_DIA_SEMANA: count })
        if (stateObject) array.push(stateObject)
        else array.push({ NUM_DIA_SEMANA: count, NUM_TOTAL_CUPONS: 0 })
      }
      return array
    },
    arrayMes() {
      let array = []
      for (let count of range(1, 32)) {
        let stateObject = find(this.stateMes, { NUM_DIA: count })
        if (stateObject) array.push(stateObject)
        else array.push({ NUM_DIA: count, NUM_TOTAL_CUPONS: 0 })
      }
      return array
    },
    tabelaHorasMaioresCompras() {
      return orderBy(this.arrayHora, 'NUM_TOTAL_CUPONS', 'desc')
    },
    tabelaDiasMaioresCompras() {
      return orderBy(this.arrayMes, 'NUM_TOTAL_CUPONS', 'desc')
    },
    tabelaDiasSemanaMaioresCompras() {
      return orderBy(this.arraySemana, 'NUM_TOTAL_CUPONS', 'desc')
    },
    chartHorasMaioresCompras() {
      return assertArray(this.arrayHora)
    },
    chartDiasMaioresCompras() {
      return assertArray(this.arrayMes)
    },
    chartDiasSemanaMaioresCompras() {
      return assertArray(this.arraySemana)
    },
    clienteNomeCodigo() {
      if (!this.clienteSelecionado) return ''
      return `${this.clienteSelecionado['COD_ID_CLIENTE_SEARCH']} - ${this.clienteSelecionado['NOM_NOME_SEARCH']}`
    },
    cards() {
      return [
        {
          value: localeString(this.faturamento || 0, 0),
          text: 'Valor total gasto pelo cliente',
          isCurrency: true,
          loader: ['primeiro-registro', 'ticket-medio'],
        },
        {
          value: localeString(this.numeroCupons || 0, 0),
          text: 'Número de cupons',
          isInteger: true,
          loader: ['primeiro-registro', 'ticket-medio'],
        },
        {
          value: localeString(this.ticketMedioClientes || 0, 0),
          text: 'Ticket médio',
          isCurrency: true,
          align: 'left',

          loader: ['primeiro-registro', 'ticket-medio'],
        },
        {
          value: localeString(this.mediaItensClientes || 0, 0),
          text: 'Média de itens na cesta',
          loader: ['primeiro-registro', 'media-itens'],
        },
      ]
    },
    tableHeaders() {
      return [
        {
          text: 'ID',
          sortable: false,
        },
        {
          text: 'Nome',
          sortable: false,
        },
        {
          text: 'Bairro',
          sortable: false,
        },
        {
          text: 'Tipo de pessoa',
          sortable: false,
        },
        {
          text: 'Sexo',
          sortable: false,
        },
        {
          text: 'Idade',
          sortable: false,
          align: 'right',
        },
      ]
    },
  },
  async mounted() {
    this.$vuetify.goTo(this.$refs['base-page'], { offset: 0 })

    await this.searchFromComponent()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getClienteDetalhes)
      this.$bus.$on('search', this.searchFromComponent)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
    this.$bus.$off('search')
  },
  methods: {
    ...mapActions(['buscaClientes']),
    ...mapWaitingActions({
      clientesTicketMedio: 'ticket-medio',
      clientesMediaItens: 'media-itens',
      clientesHorasMaioresCompras: 'horas-compras',
      clientesDiasMaioresCompras: 'dias-compras',
      clientesDiasSemanaMaioresCompras: 'semana-compras',
      produtosMaisFaturadosTop: 'produtos-top',
    }),
    getClienteDetalhes() {
      if (this.clienteSelecionado) {
        const filter = {
          cliente: this.clienteSelecionado['COD_ID_CLIENTE_SEARCH'],
          unidades: this.stateFilters.unitsConfiguration,
          date: this.stateFilters.data,
        }
        this.clientesTicketMedio(filter)
        this.clientesMediaItens(filter)
        this.clientesHorasMaioresCompras(filter)
        this.clientesDiasMaioresCompras(filter)
        this.clientesDiasSemanaMaioresCompras(filter)
        this.produtosMaisFaturadosTop(filter)
      }
    },
    back() {
      this.$router.push({ path: '/clientes/busca-cliente' }).catch(() => {})
    },
    async buscaClienteById() {
      try {
        this.loading = true
        const { data } = await this.buscaClientes({
          cliente: this.$route.params.id,
          only_one: true,
        })
        this.clienteSelecionado = data
        await this.getClienteDetalhes()
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Erro ao buscar dados do cliente', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    searchFromComponent() {
      this.buscaClienteById()
    },
  },
}
</script>

<style lang="scss">
.client-details {
  .client-title {
    font-size: 24px;
  }
  .search-link {
    color: $marca-0-l40;
    cursor: pointer;
  }
  .overlay {
    width: inherit;
    z-index: 1;
    position: absolute;
    top: 40px;
    right: 24px;
  }
}
</style>
